// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1guBj","label":"LabeledBox_label__3MtCo"};